import React from 'react';
import './Instances.css';
import InstanceCard from '../UI/InstanceCard';
import { useSelector } from 'react-redux';
import SkeletonCard from '../UI/SkeletonCard';
import { useInstanceManagement } from '../hooks/useInstanceManagement';

export const Instances = () => {
    const isOpen = useSelector((state) => state.ui.isSidebarOpen);

    // Use custom hook for all env management logic
    const {
        instances,
        isLoading,
        error,
        timeAgo,
        handleDeleteEnv,
        refreshEnvironment,
        handleResume,
        handlePause,
        handleStart,
    } = useInstanceManagement();


    return (
        <div className="main-content">
            <div className="instances-title-wrapper" style={{ paddingLeft: isOpen ? '10px' : '20px' }}>
                <div className="instances-toolkit-title">
                    Instances<br />
                    <span className="instances-toolkit-title-subheader">
                        Manage all your instances here
                    </span>
                </div>
            </div>
            <div className="instance-software-listing-wrapper">
                {isLoading && (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            padding: '20px',
                            width: '100%',
                        }}
                    >
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14].map((index) => (
                            <SkeletonCard key={index} />
                        ))}
                    </div>
                )}

                {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}

                {!isLoading && !error && instances.length === 0 && (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <p
                            style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                textAlign: 'center',
                            }}
                        >
                            No instances available. Try creating one.
                        </p>
                    </div>
                )}

                {!isLoading &&
                    !error &&
                    instances.map((instance) => (
                        <InstanceCard
                            key={instance.envName}
                            title={instance.templateName}
                            environmentId={instance.envName}
                            envExports={instance?.envExports}
                            time={timeAgo(instance?.createdAt)}
                            templateinfo={instance?.templateInformation}
                            status={instance?.envStatus}
                            handleDeleteEnv={handleDeleteEnv}
                            refreshInstances={refreshEnvironment}
                            onResume={() => handleResume(instance.envName)}
                            onPause={() => handlePause(instance.envName)}
                            onStart={() => handleStart(instance.envName)}
                        />
                    ))}
            </div>
        </div>
    );
};
